<!-- @format -->

<div class="tab-component hmf-mb-l hmf-mb-m-xxl">
	<div class="tab-banner position-relative">
		<span>
			<dsg-media
				*ngIf="data[0].visualAssets"
				[visualAssets]="data[0].visualAssets"
				[image]="data[0].image || ''"
				[itemTitle]="data[0].title"
				[altText]="''"
				[willLazyLoad]="true"
				[imagePagePosition]="addlData.tagSectionNum">
			</dsg-media>
		</span>
		<div
			class="tab-banner-title d-flex"
			*ngIf="data[0].title">
			<h3 class="hmf-pl-m-m">
				{{ data[0].title }}
			</h3>
		</div>
	</div>
	<mat-tab-group
		animationDuration="0ms"
		mat-stretch-tabs>
		<ng-container *ngFor="let datum of data; let i = index">
			<mat-tab label="{{ datum.tabName }}">
				<div
					[ngClass]="
						datum.tabbingContent.length === 1
							? 'tab-card-container'
							: 'tab-cards-container d-flex'
					">
					<ng-container *ngFor="let content of datum.tabbingContent; let j = index">
						<a
							*ngIf="datum.tabbingContent.length > 1 && content.link; else elseBlock"
							class="tab-cards-with-link"
							[href]="content.link"
							[attr.data-em]="createTag(i + 1, j + 1, content.link, '')"
							tabindex="0">
							<ng-template [ngTemplateOutlet]="componentCard"></ng-template>
						</a>
						<ng-template #elseBlock>
							<ng-template [ngTemplateOutlet]="componentCard"></ng-template>
						</ng-template>
						<ng-template #componentCard>
							<div
								[ngClass]="
									datum.tabbingContent.length === 1
										? 'tab-card'
										: content.link
										? 'tab-cards'
										: 'tab-cards tab-cards-no-link'
								"
								class="tab-card-special">
								<img
									*ngIf="content.imageUpload"
									src="{{
										'https://images.dickssportinggoods.com/marketing/' +
											content.imageUpload
									}}" />
								<div
									[ngClass]="
										datum.tabbingContent.length === 1
											? 'tab-card-info hmf-pl-s-xs hmf-pl-m-l'
											: 'tab-cards-info hmf-pl-xxs'
									">
									<home-wysiwyg
										*ngIf="content.wysiwyg"
										[data]="[content]"
										[addlData]="addlData">
									</home-wysiwyg>
								</div>
							</div>
						</ng-template>
					</ng-container>
				</div>
			</mat-tab>
		</ng-container>
	</mat-tab-group>
</div>
